import { FC, MouseEvent, useRef } from 'react';
import styled from 'styled-components';

import { CloseButton, StyledDialog } from '@/components/AlertDialogs/Dialog';
import Button from '@/components/Button';
import { Modal } from '@/components/Modal';
import Text from '@/components/Text';
import { PaymentBank } from '@/utils/enums';

const Dialog = styled(StyledDialog)`
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
`;

const Headings = styled.div`
  margin-bottom: 42px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
`;

const StyledButton = styled(Button)`
  font-weight: 600;
  &:hover,
  &:active {
    border-color: ${({ theme }) => theme.colors.purple};
  }
`;

const BANK_LABELS: Record<PaymentBank, string> = {
  [PaymentBank.REVOLUT]: 'Revolut',
  [PaymentBank.PAYPAL]: 'PayPal',
  [PaymentBank.SWEDBANK]: 'Swedbank',
  [PaymentBank.PAYONEER]: 'Payoneer',
};

interface Props {
  onClose: () => void;
  onSelect: (bank: PaymentBank) => void;
}

const InvoicesPaidBankModal: FC<Props> = ({ onClose, onSelect }) => {
  const ref = useRef<HTMLDivElement>(null);

  const onCloseWithEventPrevention = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Modal zIndex={50}>
      <Dialog
        ref={ref}
        initial={{ scale: 0.3 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.3 }}
      >
        <CloseButton onClick={onCloseWithEventPrevention}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 13L1 1"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CloseButton>
        <Headings>
          <Text $type="heading2">Paid by bank:</Text>
        </Headings>
        <List>
          {Object.values(PaymentBank).map((bank) => (
            <StyledButton
              key={bank}
              type="button"
              color="secondary"
              onClick={(e: MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                onSelect(bank);
              }}
            >
              {BANK_LABELS[bank]}
            </StyledButton>
          ))}
        </List>
      </Dialog>
    </Modal>
  );
};

export default InvoicesPaidBankModal;
